import { ContextProvider } from '@/app/providers/ContextProvider';
import { LocaleProvider } from '@/app/providers/LocaleProvider';
import RouterProvider from '@/app/providers/RouterProvider';
import QueryProvider from '@/app/providers/QueryProvider';
import { saveURLSearchParams } from '@/shared/lib/urlService.ts';

saveURLSearchParams();

function App() {
  return (
    <ContextProvider>
      <LocaleProvider>
        <QueryProvider>{RouterProvider}</QueryProvider>
      </LocaleProvider>
    </ContextProvider>
  );
}

export default App;
